// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__27yIc","left":"InfoRow_left__3kRV9"};